/** Per-field override marker stored in a bilaga's `values` blob. */
export function overrideKey(fieldKey) {
    return `__override_${fieldKey}`;
}
/**
 * Resolve an attachment template's effective values by overlaying every
 * `derivedFromParent` field with the parent contract's current value
 * (per ADR-0028 addendum 2026-05-27) — unless the user has explicitly
 * overridden that field (`__override_<key> === true`).
 *
 * Used both by the bilaga editor's live preview and by the server render
 * pipeline, so what the user sees locked is exactly what gets rendered.
 */
export function applyDerivedFromParent(fields, parentValues, ownValues) {
    const out = { ...ownValues };
    for (const f of fields) {
        if (!f.derivedFromParent)
            continue;
        if (ownValues[overrideKey(f.key)] === true)
            continue;
        const srcKey = f.derivedFrom ?? f.key;
        if (Object.prototype.hasOwnProperty.call(parentValues, srcKey)) {
            out[f.key] = parentValues[srcKey];
        }
    }
    return out;
}
/** True when a derived field is currently locked (synced, not overridden). */
export function isDerivedLocked(field, ownValues) {
    return (field.derivedFromParent === true &&
        ownValues[overrideKey(field.key)] !== true);
}
//# sourceMappingURL=derived-fields.js.map